<template>
    <div class="main-view" v-show="initFinished">
        <div class="m-title">
            <div style="display: flex;height: 70px;align-items: center;">
                <van-icon @click="back"  style="margin-right: 15px;" name="arrow-left" size="25"/>
                绑定手机
            </div>
        </div>

        <van-form v-if="!isBind" @submit="onSubmit" ref="submitForm" style="margin-top: 110px;">
            <div class="form-view">
                <div style="color: #888888;font-size: 12px;text-align: left;margin: 0 15px;">
                    为了帐号安全，请及时绑定手机号码。
                </div>

                <span class="ds-label">手机号码</span>
                <van-field label-class="inline-label" placeholder="请输入手机号" type="number" maxlength="11" style="margin-top: 2px;color: #ffffff;"  v-model="tel" clearable/>

                <span class="ds-label">验证码</span>
                <van-field label-class="inline-label" style="margin-top: 2px;" maxlength="6"
                           v-model="verifyCode" type="number" placeholder="请输入验证码">
                    <template #button>
                        <van-count-down
                            v-show="showCountDown"
                            ref="countDown"
                            :time="60000"
                            :auto-start="false"
                            format="重新发送(ss秒)"
                            style="font-size: 12px;color: #888888"
                            @finish="finish"
                        />
                        <span style="color: #4375f8;font-size: 14px;cursor: pointer;" v-show="!showCountDown" @click="sendSmsForBind">发送验证码</span>
                    </template>
                </van-field>

                <div class="box-button">
                    <van-button type="info" block native-type="submit" size="small" :loading="loading" round style="width: 160px;"
                                color="#4375f8">
                        立即绑定
                    </van-button>
                </div>

            </div>
        </van-form>

        <van-form v-else @submit="onSubmitUnbind" ref="submitForm" style="margin-top: 110px;">
            <div class="form-view">
                <div style="color: #888888;font-size: 12px;text-align: left;margin: 0 15px;">
                    当前账号已绑定手机
                </div>

                <span class="ds-label">手机号码</span>
                <van-field label-class="inline-label" placeholder="请输入手机号" style="margin-top: 2px;color: #ffffff;"  v-model="tel" readonly  maxlength="11" />

                <div v-if="!showUnbind" style="text-align: right;margin: 10px 20px;">
                    <span style="color: #aaaaaa;font-size: 14px;cursor: pointer;"  @click="showUnbind = true;">解绑该手机？</span>
                </div>

                <div v-else>
                    <span class="ds-label">验证码</span>
                    <van-field label-class="inline-label" style="margin-top: 2px;" maxlength="6"
                               v-model="verifyCode" type="number" placeholder="请输入验证码">
                        <template #button>
                            <van-count-down
                                v-show="showCountDown"
                                ref="countDown"
                                :time="60000"
                                :auto-start="false"
                                format="重新发送(ss秒)"
                                style="font-size: 14px;color: #888888"
                                @finish="finish"
                            />
                            <span style="color: #4375f8;font-size: 14px;cursor: pointer;" v-show="!showCountDown" @click="sendSmsUnbind">发送验证码</span>
                        </template>
                    </van-field>

                    <div style="color: #aaaaaa;font-size: 13px;text-align: left;margin: 20px 15px 10px;">
                        <van-icon name="warning-o" style="margin-right: 6px;"/>当前操作会解绑手机号码，请谨慎操作
                    </div>

                    <div class="box-button">
                        <van-button type="info" block native-type="submit" size="small" :loading="loading" round style="width: 160px;"
                                    color="#4375f8">
                            确认解绑
                        </van-button>

                    </div>
                </div>
            </div>

        </van-form>



    </div>
</template>
<script>

    import {Toast} from "vant";
    import {bindPhone, sendSms, webTokenRequest} from "@/api/request";
    import webConfig from "@/api/config";

    export default {
        name: 'app-tel',
        components: {
        },
        data() {
            return {
                tel: '',
                isBind: false,
                verifyCode: '',
                missShow: false,
                backShow: true,
                telPattern: /^1\d{10}$/,
                codePattern: /^\d{6}$/,
                showCountDown: false,
                showSendText: true,
                disabledSend: false,
                loading: false,
                showUnbind: false,
                initFinished: false,
            }
        },
        mounted() {
            this.refreshLoginInfo();
        },
        methods: {
            back() {
                this.$router.back();
            },
            refreshLoginInfo() {
                let options = {
                    url:"/web/getLoginInfo",
                    method: 'get'
                };
                webTokenRequest(options).then((res) => {
                    if (res.data.success === true) {
                        this.baseInfo = res.data.data;
                        localStorage.setItem('web_baseInfo', JSON.stringify(this.baseInfo));
                        this.initPage();
                        this.initFinished = true;
                    } else {
                        Toast.fail('登录已失效，请重新登录');
                        localStorage.removeItem('web_baseInfo');
                        localStorage.removeItem('web_token');
                        this.back();
                    }
                });
            },
            initPage() {
                this.verifyCode = '';
                let baseInfo = JSON.parse(localStorage.getItem('web_baseInfo'));
                if (baseInfo) {
                    let phone = baseInfo.phone;
                    if (phone) {
                        this.isBind = true;
                        this.tel = phone;
                    }
                    else {
                        this.isBind = false;
                        this.tel = '';
                    }
                }
                this.showUnbind = false;
                this.finish();
            },
            onSubmit() {
                let ok = this.checkForm();
                if (ok !== 'ok') {
                    Toast(ok);
                    return;
                }

                this.loading = true;
                let options = {
                    url:"/web/bindPhone",
                    data: {
                        phone: this.tel,
                        checkCode: this.verifyCode,
                    }
                };
                webTokenRequest(options).then((res) => {
                    this.loading = false;
                    if (res.data.success === true) {
                        Toast.success('手机号码绑定成功');
                        let user = JSON.parse(localStorage.getItem('user'));
                        user.phone = this.tel;
                        localStorage.setItem('user', JSON.stringify(user));

                        this.back();
                    } else {
                        Toast.fail(res.data.error.message);
                    }
                });
            },
            onSubmitUnbind() {
                let ok = this.checkCode();
                if (ok !== 'ok') {
                    Toast(ok);
                    return;
                }

                let options = {
                    url:"/web/unBindPhone",
                    data: {
                        checkCode: this.verifyCode,
                    }
                };
                webTokenRequest(options).then((res) => {
                    if (res.data.success === true) {
                        Toast.success('手机号码解绑成功');
                        this.refreshLoginInfo();
                    } else {
                        Toast.fail(res.data.error.message);
                    }
                });
            },
            sendSmsForBind() {
                let ok = this.checkTel();
                if (ok !== 'ok') {
                    Toast(ok);
                    return;
                }
                this.disabledSend = true;
                this.showSendText = false;
                this.showCountDown = true;
                this.$refs.countDown.start();

                let options = {
                    url:"/web/sendSms",
                    data: {
                        phone: this.tel,
                        type: '2',
                    }
                };
                webTokenRequest(options).then((res) => {
                    if (res.data.success === true) {
                        Toast('验证码发送成功');
                    } else {
                        Toast(res.data.error.message);
                        this.finish();
                    }
                });
            },
            sendSmsUnbind() {
                this.disabledSend = true;
                this.showSendText = false;
                this.showCountDown = true;
                this.$refs.countDown.start();

                let options = {
                    url:"/web/checkAndSendSms?type=3",
                    method: 'get'
                };
                webTokenRequest(options).then((res) => {
                    if (res.data.success === true) {
                        if (res.data.data === '1') {
                            Toast('验证码发送成功');
                        }
                        else {
                            this.initPage();
                            Toast('当前账号未绑定手机');
                        }
                    } else {
                        Toast(res.data.error.message);
                        this.finish();
                    }
                });
            },
            checkTel() {
                if (!this.tel) {
                    return "请输入手机号码";
                }
                if (!this.telPattern.test(this.tel)) {
                    return "请输入正确的手机号码";
                }
                return 'ok';
            },
            checkForm() {
                if (!this.tel) {
                    return "请输入手机号码";
                }
                if (!this.telPattern.test(this.tel)) {
                    return "请输入正确的手机号码";
                }
                if (!this.verifyCode) {
                    return "请输入验证码";
                }
                if (!this.codePattern.test(this.verifyCode)) {
                    return "验证码为6位数字";
                }
                return 'ok';
            },
            finish() {
                this.disabledSend = false;
                this.showSendText = true;
                this.showCountDown = false;
                this.$refs.countDown.reset();
            },
            checkCode() {
                if (!this.verifyCode) {
                    return "请输入验证码";
                }
                if (!this.codePattern.test(this.verifyCode)) {
                    return "验证码为6位数字";
                }
                return 'ok';
            },
        }
    }
</script>

<style scoped>
    .main-view {
        width: 100%;
        height: 100vh;
        overflow-x: hidden;
        overflow-y: auto;
        background-color: #eaedf6;
    }
    .m-title {
        display: flex;
        font-size: 20px;
        color: #333333;
        width: 100%;
        height: 110px;
        text-align: left;
        align-items: flex-end;
        padding: 0 10px;
        position: fixed;
        z-index: 999;
        background-color: #eaedf6;
        box-sizing: border-box;
    }
    .ds-label {
        display: inline-block;
        width: 100%;
        text-align: left;
        margin: 15px 15px 0;
        font-size: 14px;
    }

    /deep/.inline-label {
        color: #aaaaaa !important;
    }
    .van-cell{
        padding: 8px 14px;
    }
    .van-cell::after {
        border-bottom: 1px solid #333333;
    }
    .box-button {
        margin: 30px 0 10px;
        display: flex;
        justify-content: center;
    }
    .form-view {
        margin: 60px 15px 0;
        background-color: #ffffff;
        border-radius: 8px;
        padding: 20px 10px 20px;
    }
</style>
